import connect from 'components/Shared/connect';
import { IconCustomerPages } from 'components/Shared/Icon/themes/BGH-RD3/iconCustomerPages';
import { isLayout, isMobile, isTablet } from 'components/Shared/responsive';
import { NO_ELEMENT } from 'utils';
import styles from './styles.scss';
import { NavigationBlock } from 'models/NavigationBlock';
import cn from 'classnames';
import { IconHelpCenterOpt } from 'components/Shared/Icon';

type KindOfLink = 'CustomerPage' | 'HelpCenter';
interface OwnProps {
  className?: string;
  navBlock?: NavigationBlock;
  type: KindOfLink;
}

interface MergedProps extends OwnProps {
  visible: boolean;
}

const TopBarLink = ({ visible, navBlock, type }: MergedProps) => {
  if (!visible || !navBlock?.items[0].url || !navBlock?.header) {
    return NO_ELEMENT;
  }

  return (
    <a href={navBlock.items[0].url} className={cn(styles.customerPages)}>
      {type === 'CustomerPage' ? (
        <IconCustomerPages className={styles.icon} />
      ) : (
        <IconHelpCenterOpt className={styles.icon} />
      )}
      <span className={cn(styles.tagline)}>{navBlock.header}</span>
    </a>
  );
};

const isLegacy = (channel: string): boolean => {
  return channel === 'GOP';
};

export default connect<MergedProps, OwnProps>(state => {
  return {
    visible: isLegacy(state.appShell.channel)
      ? !isLayout(isMobile)(state)
      : !isLayout(isMobile, isTablet)(state)
  };
})(TopBarLink);
